import { render, staticRenderFns } from "./LocationReports.vue?vue&type=template&id=23f2042e"
import script from "./LocationReports.vue?vue&type=script&lang=js"
export * from "./LocationReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports